import React from 'react';
import { Clock } from 'lucide-react';

/**
 * クイズタイマー表示コンポーネント
 * - 一貫性のあるタイマー表示
 * - 視覚的な警告表示
 * - アクセシビリティ対応
 */
const TimerDisplay = ({ 
  timeRemaining, 
  isActive, 
  showWarning = true,
  size = 'default',
  className = ''
}) => {
  // 時間を分と秒に変換
  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  
  // 警告状態の判定（残り時間が60秒以下で警告）
  const isWarning = showWarning && timeRemaining <= 60 && timeRemaining > 0;
  const isCritical = showWarning && timeRemaining <= 30 && timeRemaining > 0;
  
  // サイズに応じたスタイル
  const sizeClasses = {
    small: 'text-sm',
    default: 'text-base',
    large: 'text-lg font-semibold'
  };
  
  // 状態に応じた色クラス
  const getColorClasses = () => {
    if (!isActive) {
      return 'text-gray-400 bg-gray-100';
    }
    if (isCritical) {
      return 'text-red-600 bg-red-50 animate-pulse';
    }
    if (isWarning) {
      return 'text-orange-600 bg-orange-50';
    }
    return 'text-green-600 bg-green-50';
  };
  
  if (timeRemaining < 0) {
    return null; // 負の値の場合は表示しない
  }
  
  return (
    <div 
      className={`
        inline-flex items-center gap-2 px-3 py-2 rounded-lg border transition-all duration-300
        ${getColorClasses()}
        ${sizeClasses[size]}
        ${className}
      `}
      role="timer"
      aria-label={`残り時間 ${formattedTime}`}
      aria-live="polite"
    >
      <Clock 
        size={size === 'small' ? 14 : size === 'large' ? 20 : 16} 
        className={isActive ? 'animate-pulse' : ''} 
      />
      <span className="font-mono">
        {formattedTime}
      </span>
      {isCritical && (
        <span className="text-xs font-bold animate-bounce">
          ⚠️
        </span>
      )}
    </div>
  );
};

export default TimerDisplay; 